import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';

import { DateFormats } from 'utils/constants';
import Date from './Date';

dayjs.extend(isToday);
dayjs.extend(isTomorrow);

type DayOfTheWeekProps = {
  date: string | number;
  className?: string;
  relative?: boolean;
};

function DayOfTheWeek({ date, className, relative }: DayOfTheWeekProps) {
  let relativeDayOfTheWeek;
  if (relative) {
    const theDate = dayjs(date);
    if (theDate.isToday()) {
      relativeDayOfTheWeek = 'Today';
    } else if (theDate.isTomorrow()) {
      relativeDayOfTheWeek = 'Tomorrow';
    }
  }

  if (relativeDayOfTheWeek) {
    return (
      <span data-testid="day-of-the-week" className={className}>
        {relativeDayOfTheWeek}
      </span>
    );
  }

  return <Date date={date} format={DateFormats.DAY_OF_WEEK} className={className} />;
}

export default DayOfTheWeek;
